/** */
export const fmt = (value, format) => {
  if (value === null || value === undefined) return '—';
  const n = Number(value);
  if (isNaN(n)) return '—';
  switch (format) {
    case 'currency':
      if (n >= 1000000) return `₦${(n / 1000000).toFixed(2)}M`;
      if (n >= 1000) return `₦${(n / 1000).toFixed(1)}K`;
      return `₦${n.toLocaleString()}`;
    case 'percent':
      return `${n.toFixed(2)}%`;
    case 'hours':
      if (n === 0) return '—';
      return n < 1 ? `${Math.round(n * 60)}m` : `${n.toFixed(1)}h`;
    case 'days':
      return n === 0 ? '—' : `${n.toFixed(1)}d`;
    default:
      if (n >= 1000000) return `${(n / 1000000).toFixed(1)}M`;
      if (n >= 1000) return `${(n / 1000).toFixed(1)}K`;
      return `${Math.round(n)}`;
  }
};
